import { requests } from '@/libs/axios/axios'
import { NotificationEndPoints } from '../notification-endpoints'
import { AxiosResponse } from 'axios'
const getNotifications = async (offset: number, limit: number): Promise<AxiosResponse> => {
  return requests.get(`${NotificationEndPoints.GET_NOTIFICATIONS}?offset=${offset}&limit=${limit}`)
}
export default getNotifications
